import { SearchModes } from './constants'
import type {
  SearchFilterState,
  SearchMetaOptions,
  SearchQueryPayload,
} from './types'

export const createDefaultSearchState = (): SearchFilterState => ({
  searchText: '',
  mediaType: {
    document: true,
    image: true,
    video: true,
  },
  industries: {},
  status: {
    current: true,
    nonCurrent: false,
  },
  documentInformation: {
    mediaNumber: '',
    categories: [],
    productTypes: [],
    subIndustries: [],
  },
  productInformation: {
    engineModels: [],
    performanceNo: '',
    revisionNo: '',
    emissionTiers: [],
    targetRegions: [],
    duties: [],
    sources: [],
    fuelTypes: [],
    frequencies: [],
    rpms: [],
    voltages: [],
    applications: [],
    ratings: {
      kva: '',
      bkw: '',
      bhp: '',
      mhp: '',
      ekw: '',
    },
    countryOfUse: [],
    GERP: false,
    CSQ: false,
    TIP: false,
    excitation: [],
    generatorArrangement: '',
    configurableSalesModel: '',
    featureCode: '',
    electricPowerSpecSizer: false,
    catDotComProductTechnicalInformation: false,
    appliesTo: '',
    powerDotCatDotCom: false,
  },
  advancedTextSearching: {
    title: '',
    keyword: '',
    longDescription: '',
  },
  mediaDetails: {
    securedFrom: null,
    securedTo: null,
    modifiedFrom: null,
    modifiedTo: null,
    languages: [],
    provider: [],
    providerMode: 'include',
    affiliationCode: '',
    productId: '',
  },
})

export const defaultSearchState: SearchFilterState = createDefaultSearchState()

export const defaultSearchQuery: Omit<SearchQueryPayload, 'options'> = {
  searchCriteria: 'Images,Documents,Videos|Status:Current',
  searchText: '',
  customSearchOptions: {
    singleIncludes: {
      mediaType: ['D', 'I', 'V'],
      status: ['C'],
    },
    collectionIncludes: {
      productTypes: [],
      engineMarkets: [],
      regions: [],
      categories: [],
      subIndustries: [],
      engineModels: [],
      emissionTiers: [],
      duties: [],
      sources: [],
      fuelTypes: [],
      frequencies: [],
      rpms: [],
      voltages: [],
      applications: [],
      languages: [],
    },
    containsStringIncludes: {
      title: '',
      keywords: '',
      longDescription: '',
      mediaNumber: '',
    },
    dateIncludes: {
      fromDateModified: null,
      toDateModified: null,
      fromSecureDate: null,
      toSecureDate: null,
    },
    specificObjectIncludes: {
      ratingBhp: '',
      ratingBkw: '',
      ratingEkw: '',
      ratingKva: '',
      ratingMhp: '',
      affiliationCodes: '',
      performanceNo: '',
      revisionNo: '',
      productIds: '',
    },
    specificObjectMultiples: { provider: { include: [], exclude: [] } },
    xMetaDataIncludes: [],
  },
}

export const defaultSearchResultOptions: SearchMetaOptions = {
  searchMode: SearchModes.All,
  orderBy: [{ field: 'secureDate', sort: 'desc' }],
  size: 25,
  skip: 0,
  includeTotalCount: true,
}
